import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const ChatPage = lazy(() => import('./pages/ChatPage').then(m => ({ default: m.ChatPage })));
const AnnouncementsPage = lazy(() =>
  import('./pages/AnnouncementsPage').then(m => ({ default: m.AnnouncementsPage }))
);
const ModerationPage = lazy(() =>
  import('./pages/ModerationPage').then(m => ({ default: m.ModerationPage }))
);

/**
 * Chat is a surface EVERY role reaches — parents included, since routing a
 * parent's question to a teacher is the point of the feature (backend ADR-020).
 * The roles are spelled out rather than omitted: an omitted list means "any
 * authenticated role", which would let an unrecognised one through
 * (deny-by-default, FE-ADR-005).
 */
export const chatRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
    <Route path="/chats" element={<ChatPage />} />
  </Route>
);

/** Announcements are readable by every role; the server shapes WHAT each of
 *  them sees (staff all, pupils their classes, parents their children's). */
export const announcementRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
    <Route path="/announcements" element={<AnnouncementsPage />} />
  </Route>
);

/**
 * The report queue is a map of who said what to whom — admin only, exactly
 * like `GET /api/message-reports/`.
 */
export const moderationRoutes = (
  <Route element={<RequireRole roles={['admin']} />}>
    <Route path="/moderation" element={<ModerationPage />} />
  </Route>
);
